import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import { Doughnut } from "react-chartjs-2";
import { grey } from "@mui/material/colors";
import {
  Card as MuiCard,
  CardContent,
  CardHeader,
  Typography,
  Box,
} from "@mui/material";
import { spacing } from "@mui/system";

const Card = styled(MuiCard)(spacing);

const ChartWrapper = styled.div`
  height: 240px;
  position: relative;
`;

const DoughnutInner = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  text-align: center;
  z-index: 0;
`;

const DoughnutChart = ({ theme, doughnutChartData }) => {
  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
        borderWidth: 5,
        borderColor: theme.palette.background.paper,
      },
    ],
  });
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    if (doughnutChartData) {
      const labels = doughnutChartData.map((item) => item.stato);
      const dataValues = doughnutChartData.map((item) => item.Tot);
      const total = dataValues.reduce((acc, curr) => acc + curr, 0);

      const backgroundColor = doughnutChartData.map((item) => {
        switch (item.stato) {
          case "Closed":
            return "#4caf50"; // Green
          case "In Progress":
          case "Analysis":
            return "#f48b36"; // Orange
          case "Open":
            return "#16669bff"; // Blue
          case "Suspended":
            return "#f44336"; // Red
          default:
            return grey[300];
        }
      });

      setData({
        labels,
        datasets: [
          {
            data: dataValues,
            backgroundColor,
            borderWidth: 5,
            borderColor: theme.palette.background.paper,
          },
        ],
      });

      setTotalRecords(total);
    }
  }, [doughnutChartData, theme.palette.background.paper]);

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        labels: {
          color: theme.palette.mode === "dark" ? "white" : "black",
        },
      },
    },
    cutout: "80%",
  };

  return (
    <Card mb={4} sx={{ height: "100%" }}>
      <CardHeader title="Stato Richieste" />
      <CardContent>
        <ChartWrapper>
          <DoughnutInner>
            <Typography variant="h4">{totalRecords}</Typography>
            <Typography variant="caption">Totali</Typography>
          </DoughnutInner>
          <Doughnut data={data} options={options} />
        </ChartWrapper>
      </CardContent>
    </Card>
  );
};

export default withTheme(DoughnutChart);
